import { render, staticRenderFns } from "./sanitation.vue?vue&type=template&id=76f09a2f&scoped=true&"
import script from "./sanitation.vue?vue&type=script&lang=js&"
export * from "./sanitation.vue?vue&type=script&lang=js&"
import style0 from "./sanitation.vue?vue&type=style&index=0&id=76f09a2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f09a2f",
  null
  
)

export default component.exports